import React, { useState, useEffect } from 'react';
import Modal from 'react-bootstrap/Modal';
import Select from 'react-select';
import { useTranslation } from 'react-i18next';
import { customStylesWhite } from '../helper';
import Loader from '../Utility/Loader/Loader';

function FilePreview({ onOpen, fileObj, toggle, pageList, handlePreviewChangePage, previewLoader, previewPageId }) {
  const [state, setState] = useState({
    isSupported: true,
    fileURL: '',
    mimeType: '',
    fileName: '',
    ext: '',
    loader: true,
  });
  const { t } = useTranslation('common');

  const getExtensionFromUrl = (url) => {
    const {pathname} = new URL(url);
    const lastSegment = pathname.split('/').pop();
    return lastSegment.includes('.') ? lastSegment.split('.').pop().toLowerCase() : '';
  };

  useEffect(() => {
    const { fileName, mimeType, path } = fileObj;
    if (path) {
      const ext = getExtensionFromUrl(path);

      setState((sta) => ({
        ...sta,
        loader: false,
        fileName: fileName || t('FILE_PREVIEW.DOCUMENT_VIEWER'),
        ext,
        mimeType,
        fileURL: path,
      }));
    }
  }, [fileObj, t]);

  return (
    <Modal show={onOpen} backdrop="static" className="common-custom-modal modal-medium relative-width-modal" aria-labelledby="contained-modal-title-vcenter">
      <Modal.Header>
        {pageList?.length > 0 && (
          <div className="w-300px preview-product-select">
            <Select
              name="pageList"
              options={pageList}
              getOptionLabel={({ pageTitle }) => `${pageTitle}`}
              getOptionValue={({ _id }) => `${_id}`}
              value={pageList?.find(({ _id }) => _id === previewPageId)}
              onChange={handlePreviewChangePage}
              styles={customStylesWhite}
              className="common-select"
              classNamePrefix="common-select"
              isDisabled={previewLoader}
              placeholder={t('CUSTOM_MODULE.SELECT_LIB_PAGE')}
            />
          </div>
        )}
        <Modal.Title id="contained-modal-title-vcenter">
          <span>{fileObj?.fileName}</span>
        </Modal.Title>
        <span onClick={toggle} className="icon-close ml-auto cursor-pointer text-dark  text-decoration-none" />
      </Modal.Header>
      <Modal.Body>
        {!state.loader &&
          (state.isSupported ? (
            <div className="doc-container overflow-hidden">
              {previewLoader ? (
                <Loader />
              ) : (
                <iframe
                  title={t('FILE_PREVIEW.FILE_PREVIEWS')}
                  id="viwer"
                  // sandbox="allow-same-origin allow-scripts allow-downloads"
                  src={state.fileURL}
                  style={{ width: '100%', height: '80vh' }}
                  frameBorder="0"
                />
              )}
            </div>
          ) : (
            <div className="doc-container">
              <div className="alert alert-info override-alert-info">
                <p className="nomar">
                  <small>
                    {t('FILE_PREVIEW.THE_FILE_TYPE')} {state.mimeType} {t('FILE_PREVIEW.IS_NOT_SUPPORTED_VIEWER')}
                  </small>
                </p>
              </div>
            </div>
          ))}
      </Modal.Body>
    </Modal>
  );
}

export default FilePreview;
